import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { communityObject } from '~/packages/geo/community/communityObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'

export const roadMaintenanceObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().nullish(),
  scheduledDate: dateOrIsoString(),
  communityId: communityObject.shape.id,
  street: z.string().nullish(),
  serviceLocation: z.tuple([z.number(), z.number()]).nullish(),
  lengthMeters: z.number().nullish(),
  responsibleCitizenId: citizenObject.shape.id.nullish(),
  status: z.string().nullish(),
  observations: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type RoadMaintenanceType = z.infer<typeof roadMaintenanceObject>

export const propertyMap = {
  id: sql`id`,
  code: sql`code`,
  scheduledDate: sql`scheduled_date`,
  communityId: sql`community_id`,
  street: sql`street`,
  serviceLocation: sql`service_location`,
  lengthMeters: sql`length_meters`,
  responsibleCitizenId: sql`responsible_citizen_id`,
  status: sql`status`,
  observations: sql`observations`,
  sourceFilter: sql`road_maintenance.source_filter`,
  clientId: sql`client_id`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
